/** A situação e a prioridade de uma conversa, no nome que a tela usa (#880; saiu de `atendimento/formato.ts`). */

/** Vocabulário do domínio → o que se lê na tela. */
export const NOMES_DE_SITUACAO: Record<string, string> = {
  aberta: 'Aberta',
  pendente: 'Pendente',
  resolvida: 'Resolvida',
  em_espera: 'Adiada',
};

export const NOMES_DE_PRIORIDADE: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
};
